import {Expose, Type} from 'class-transformer';

export class UserDeletionReasonApiModel {
  @Expose()
  id: string;

  @Expose()
  name: string;
}
